import { render, staticRenderFns } from "./XpplPage.vue?vue&type=template&id=18818e06&scoped=true&"
import script from "./XpplPage.vue?vue&type=script&lang=js&"
export * from "./XpplPage.vue?vue&type=script&lang=js&"
import style0 from "./XpplPage.vue?vue&type=style&index=0&id=18818e06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18818e06",
  null
  
)

export default component.exports